import './polyfills';
import React from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/browser';
import { storyblokInit, apiPlugin } from '@storyblok/react';
import { Provider } from 'react-redux';
// eslint-disable-next-line no-unused-vars
import bootstrap from 'bootstrap';
import reportWebVitals from './reportWebVitals';
import Heatmap from './containers/App/Heatmap';
import TacticalTradingApp from './containers/App/TacticalTradingApp';
import store from './redux/store';
import AppTypeContext from './contexts/AppTypeContext';

import './index.scss';

const TACTICAL_TRADING_CENTRE = 'ttCentre';
const SHORT_AND_LEVERAGE_HEATMAP = 'slHeatmap';

// Below tokens are read only tokens and can be public thus keeping them here.

// Dev token also shows drafted changes from story blok
const STORYBLOK_DEV_TOKEN = '9XW7lqRYZqQtasQEcNk3Wgtt';

// Prod token only shows published changes from story blok
const STORYBLOK_PROD_TOKEN = 'iRzZGkOMouUHxqynd2hu6gtt';

Sentry.init({
  dsn: process.env.SENTRY_DSN,
});

storyblokInit({
  accessToken:
    process.env.REACT_APP_NODE_ENV === 'development'
      ? STORYBLOK_DEV_TOKEN
      : STORYBLOK_PROD_TOKEN,
  use: [apiPlugin],
  components: {},
});

const renderReactApp = (appId, callBack) => {
  const element = document.getElementById(appId);
  if (element) {
    const root = createRoot(element);
    root.render(
      <React.StrictMode>
        <Provider store={store}>
          <AppTypeContext.Provider value={appId}>
            <div id="app_version" style={{ display: 'none' }}>
              {process.env.REACT_APP_VERSION}
            </div>
            <div id="commit_hash" style={{ display: 'none' }}>
              {process.env.REACT_APP_COMMIT_HASH}
            </div>
            {callBack(root)}
          </AppTypeContext.Provider>
        </Provider>
      </React.StrictMode>,
    );
  }
};

renderReactApp(TACTICAL_TRADING_CENTRE, () => <TacticalTradingApp />);
renderReactApp(SHORT_AND_LEVERAGE_HEATMAP, () => <Heatmap />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
